import React               from "react"
import {useTranslation}    from "react-i18next"

import ItemNotFound  from "../common/Items/ItemNotFound"
import IconTimeLimit from "../common/Icons/TimeLimit"

const NotFound: React.FC = () => {
    const {t} = useTranslation()
    const link: string = '/time-limits'

    return (
        <ItemNotFound icon={<IconTimeLimit link={link} size="large" />}
                      link={link}
                      subTitle={t('common.item_not_found', { itemType: t('time-limits.title_item').toLowerCase() })} />
    )
}

export default NotFound